import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { UserService } from '../../../../common/services/User.service';
import { TicketService } from '../../../../common/services/Ticket.service';
import { Observable } from 'rxjs/Rx';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { OrganizeService } from '../../../../common/services/Organize.service';
import { GroupService } from '../../../../common/services/Group.service';
import { FieldService } from '../../../../common/services/Field.service';
import * as _ from 'lodash';
import { SearchService } from '../../../../common/services/Search.service';
import { ToastrService } from 'ngx-toastr';
import { SocketService } from '../../../../common/services/Socket.service';
import { CommentService } from '../../../../common/services/Comment.service';
import { CampaignService } from 'app/common/services/Campaign.service';
import { BsModalService } from 'ngx-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { UploadService } from '../../../../common/services/Upload.service';
import { CommonService } from '../../../../common/services/Common.service';
import { environment } from 'environments/environment';
import { ServiceService } from 'app/common/services/Service.service';

@Component({
    moduleId: module.id,
    selector: "search",
    templateUrl: './search.component.html',
    styleUrls: ['../../../../../css/fuck.css', './search.css'],
    providers: [UserService, TicketService, EvsAddressService, OrganizeService, GroupService,
            FieldService, SearchService, CommentService, UploadService, CommonService, CampaignService, ServiceService]
})

@Injectable()
export class SearchComponent implements OnInit {
    public choice: any = {};
    public modelFilter : any = {};
    public model: any = {
        sub_and_or: 'and',
        main_and_or: 'and'
    };
    public fields = [];
    public allAgent: any = [];
    public allCampaign: any = [];
    public allStatus: any = [];
    public allCity: any = [];
    public allGroup: any = [];
    public allOrganize: any = [];
    public tab: string = 'ticket';
    public placeholder : string = 'Tìm kiếm theo chủ đề phiếu ghi'
    public data: any = [];
    public detailTicket : any ={};
    public modalRef2: any;
    public listFilter : any = [];
    public selectFilter : any ='Bộ lọc mới';
    public filterHtml: any;
    public filter_id : any;

    public currentPage: any = 1;
    public totalItem: any = 0;
    public totalPage: any = 0;
    public page_size: number = 10;

    /************IMPORT */
    public step: number = 1;
    public file_out: any;
    public keys : any = [];
    public fieldsImport : any = [];
    public modelImport: any = {};
    public headers: any = [{ id: '', text: '' }];
    public mapping: any = {};
    public file_import: any;
    public key: any;
    public exec_import: any = 'create';
    public message: { class: string, content: string } = null;
    public current_job: any = {};
    public complete_load: number = 50;
    public userLogin : any = {};
    public cancel_import:boolean = false;
    /************IMPORT */

    constructor(
        private userService: UserService,
        private ticketService: TicketService,
        private addressService: EvsAddressService,
        private organizeService : OrganizeService,
        private groupService : GroupService,
        private fieldService: FieldService,
        private serviceService: ServiceService,
        private searchService : SearchService,
        private toastr: ToastrService,
        private socketService : SocketService,
        private commentService : CommentService,
        private modalService : BsModalService,
        private route : ActivatedRoute,
        private uploadService: UploadService,
        private commonService: CommonService,
        private campaignService: CampaignService
    ) {
        if (localStorage.getItem('User')) {
            this.userLogin = JSON.parse(localStorage.getItem('User'));
          }
    }

    ngOnInit() {
        this.initField();
        this.loadFilter();
        this.loadData();
        this.getAllCampaign();
        if(this.route.snapshot.queryParamMap.get('tab')) {
            this.changeTab(this.route.snapshot.queryParamMap.get('tab'));
        }
        this.keys = [{ id: '', text: '' },
        { id: 'phone', text: 'Điện thoại' },
        { id: 'email', text: 'Email' }];

        this.fieldsImport = [{ key: 'name', title: 'Tên' },
        { key: 'phone', title: 'Điện thoại' },
        { key: 'email', title: 'Email' },
        { key: 'address', title: 'Địa chỉ', type: 'text' },
        { key: 'facebook', title: 'Facebook' },
        { key: 'gender', title: 'Giới tính' },
        { key: 'note', title: 'Ghi chú' }];
    }

    choiceFilter(filter?:any) {
        this.selectFilter = 'Bộ lọc mới';
        this.filter_id = null;
        this.fields.forEach(e => {
            $('#dynamic-'+e.key).html('');
            // $('#group-input-condition').find('.btn-add-condition').each(function(index) {
            //     $(this).remove();
            // })
            this.choice[e.key] = false;
            $('#key-'+e.key).prop( "checked", false );
        })
        if(filter){
            this.filter_id = filter._id;
            this.selectFilter = filter.name;
            this.filterHtml = JSON.parse(filter.data);
            let data_type:any = {};
            this.fields.forEach(e => {
                data_type[e.key] = e.type;
            });
            let keys = Object.keys(this.filterHtml);
            keys.forEach(key => {
                $('#key-'+key).prop( "checked", true );
                this.choice[key] = true;
                let d = this.filterHtml[key];
                let index = 0;
                d.forEach(e => {
                    this.addCondition(key,index, data_type[key]);
                    this.addInputValue(key,index,e.label, data_type[key]);
                    $('#group-input-' + key + '-' + index + '-' + e.label).find('input:radio').prop('checked', true);
                    console.log('#value-'+key+'-'+index+'-'+e.label, e.val);
                    let _checkType = _.find(this.fields, {key : key});
                    // if(_checkType &&  _checkType.type =='select') {
                    //     $('#value-'+key+'-'+index+'-'+e.label).select2('val',e.val);
                    // }else
                    $('#value-'+key+'-'+index+'-'+e.label).val(e.val).trigger('change');
                    index ++;
                });
            });
        }
    }

    deleteFilter() {
        let y = confirm("Bạn có muốn xóa bộ lọc này không?");
        if(y){
            this.searchService.deleteFilter(this.filter_id).subscribe(res => {
                if(res.status == 200 && !res.error) {
                    this.loadFilter();
                    this.toastr.success('Xóa bộ lọc thành công', '', {
                        timeOut: 1000,
                        positionClass: 'toast-bottom-right'
                    });
                    this.selectFilter = 'Bộ lọc mới';
                    this.filter_id = null;
                    this.fields.forEach(e => {
                        $('#dynamic-'+e.key).html('');
                        $('#key-'+e.key).prop( "checked", false );
                    })
                }
            })
        }
        
    }

    addInputValue(key, id, label, type) {
        var html = ''
        if(type == 'text') {
          $('#box-'+key+'-'+id).find('.input-text').remove();
          html = `<input type="text" class="form-control input-text" style="height: 25px; margin-left: 10px;width: 230px;z-index=0;"
           id="value-`+key+`-`+id+`-`+label+`" data-key="`+key+`" data-index="`+id+`" data-label="`+label+`">`
        }else if(type == 'select') {
          $('#box-'+key+'-'+id).find('.select2').remove();
          $('#box-'+key+'-'+id).find('.group-select').remove();
           html = `<div class="group-select"><select type="text" class="form-control input-select" style="height: 25px; margin-left: 10px;width: 230px;z-index=0;"
            id="value-`+key+`-`+id+`-`+label+`" data-key="`+key+`" data-index="`+id+`" data-label="`+label+`" >`
            html += '<option value=""></option>'
            var data = $('#box-'+key).data('x');
            data.forEach(e => {
              html+='<option value="'+e.id+'">'+e.text+'</option>'
            }); 
          html +='</select></div>'
        }else if(type =='date') {
          $('#box-'+key+'-'+id).find('.input-date').remove();
          $('#box-'+key+'-'+id).find('.group-date').remove();
          html = `<div class="input-group group-date"><input type="text" data-plugin="datepicker" class="form-control input-date" style="height: 25px; margin-left: 10px;width: 230px;z-index=0;"
           id="value-`+key+`-`+id+`-`+label+`" data-key="`+key+`" data-index="`+id+`" data-label="`+label+`">`
           html +=`<span class="input-group-addon" style="height:25px">
           <i class="icon wb-calendar" aria-hidden="true"></i>
         </span></div>`
        }else if(type == 'number') {
          $('#box-'+key+'-'+id).find('.input-number').remove();
          html = `<input type="number" class="form-control input-number" style="height: 25px; margin-left: 10px;width: 230px;z-index=0;"
           id="value-`+key+`-`+id+`-`+label+`" data-key="`+key+`" data-index="`+id+`" data-label="`+label+`">`
        }
        
        $('#group-input-'+key+'-'+id+'-'+label).append(html);
        if(type =='select') {
          $('.input-select').select2({placeholder: '--chọn--', containerCss: {'font-size':'12px', 'height': '25px', "margin-top": "-2px"}});
        }
        if(type == 'date') {
            (<any>$('.input-date')).datepicker({ format: 'dd/mm/yyyy' });
        }
      }

    getForm() {
        let data = {};
        $('#group-input-condition').find('.input-text').each(function(index){
            var key = $(this).data('key');
            var label = $(this).data('label');
            var val = $(this).val();
            if(!data[key]) {
                data[key] = [{label: label, val: val}];
            }else {
                data[key].push({label: label, val: val})
            }
        })

        $('#group-input-condition').find('.input-select').each(function(index){
            var key = $(this).data('key');
            var label = $(this).data('label');
            var val = $(this).val();
            if(!data[key]) {
                data[key] = [{label: label, val: val}];
            }else {
                data[key].push({label: label, val: val})
            }
        })

        $('#group-input-condition').find('.input-date').each(function(index){
            var key = $(this).data('key');
            var label = $(this).data('label');
            var date_val = $(this).val();
            var convert_date = new Date(date_val.toString());
            var val = moment(convert_date);
            if(!data[key]) {
                data[key] = [{label: label, val: val}];
            }else {
                data[key].push({label: label, val: val})
            }
        })
        return data;

    }

    loadJob() {
        let where = {
            job_status: {
                "$in": ['pending', 'running']
            }
        }
        this.commonService.findImport({ where: JSON.stringify(where) }).subscribe(res => {
            if (!res.error && res.status == 200) {
                this.current_job = res.data;
                if (this.current_job) {
                    this.step = 3;
                    this.check();
                }
            }
        })
    }

    openModal(template: TemplateRef<any>) {
        this.modelFilter = {};
        this.message = null;
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef2 = this.modalService.show(template, config);
    }

    openModalImport(template: TemplateRef<any>) {
        this.message = null;
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef2 = this.modalService.show(template, config);
        this.modelImport = {};
        this.file_import = null;
        this.key = null;
        this.step = 1;
        this.file_out = null;
        this.mapping = {};
        this.loadJob();
    }

    changeTab(tab) {
        if(tab !=  this.tab) {
            this.model = {
                sub_and_or: 'and',
                main_and_or: 'and'
            };
            this.currentPage = 1;
            this.totalItem = 0;
            this.totalPage = 0;
            this.data = [];
            this.tab = tab;
            this.initField();
            this.loadData();
            this.loadFilter();
            this.selectFilter = 'Bộ lọc mới';
            this.filter_id = null;
            
        }
    }

    initField() {
        if(this.tab == 'ticket') {
            this.placeholder = 'Tìm kiếm theo chủ đề phiếu ghi';
            this.initFieldTicket();
        }else if(this.tab == 'user') {
            this.placeholder = 'Tìm kiếm theo tên, điện thoại hoặc email';
            this.initFiledUser()
        }else if(this.tab == 'organize') {
            this.placeholder = 'Tìm kiếm theo tên tổ chức';
            this.initFieldOrg();
        }
    }

    initFieldOrg() {
        this.fields = [
            { key: 'name', title: 'Tên', type: 'text' },
            { key: 'domain', title: 'Tên miền', type: 'text' },
            { key: 'tags', title: 'Đánh dấu', type: 'text' },
            { key: 'note', title: 'Giới thiệu', type: 'text' },
            { key: 'created_at', title: 'Ngày khởi tạo', type: 'date' },
            { key: 'updated_at', title: 'Ngày cập nhật', type: 'date' }
        ]
        this.fields.forEach(e => {
            this.choice[e.key] = false;
        });
    }
    initFiledUser() {
        Observable.forkJoin([
            this.addressService.getCities(),
            this.groupService.allGroup(),
            this.organizeService.allOrganize(),
            this.fieldService.allField({ target: 'user' })
        ]).subscribe(data => {
            let cityList = [];
            data[0].data.cities.forEach((c: any) => {
                cityList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allCity = cityList;

            let groupList = [];
            data[1].data.forEach((c: any) => {
                groupList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allGroup = groupList;

            let organizeList = [];
            data[2].data.forEach((c: any) => {
                organizeList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allOrganize = organizeList;

            this.fields = [
                { key: 'name', title: 'Tên', type: 'text' },
                { key: 'phone', title: 'Điện thoại', type: 'text' },
                { key: 'email', title: 'Email', type: 'text' },
                { key: 'facebook', title: 'Facebook', type: 'text' },
                { key: 'address', title: 'Địa chỉ', type: 'text' },
                { key: 'city_id', title: 'Thành phố', type: 'select', data: JSON.stringify(this.allCity), data_type: '_number' },
                { key: 'group_id', title: 'Bộ phận', type: 'select', data: JSON.stringify(this.allGroup), data_type: '_number'  },
                { key: 'organize_id', title: 'Tổ chức', type: 'select', data: JSON.stringify(this.allOrganize), data_type: '_number'  },
                { key: 'customer_type', title: 'Hạng khách hàng', type: 'select', data: JSON.stringify([
                    {id: '0', text: 'Thường'},
                    {id: '1', text: 'Bạc'},
                    {id: '2', text: 'Vàng'},
                    {id: '3', text: 'Kim cương'},
                ]) },
                { key: 'gender', title: 'Giới tính', type: 'select', data: JSON.stringify([
                    {id: 'male', text: 'Nam giới'},
                    {id: 'female', text: 'Nữ giới'},
                    {id: 'other', text: 'Khác'},
                ]) },

                { key: 'role', title: 'Vai trò', type: 'select', data: JSON.stringify([
                    {id: 'end_user', text: 'Khách hàng'},
                    {id: 'agent', text: 'Chuyên viên'},
                    {id: 'supervisor', text: 'Supervisor'},
                    {id: 'administrator', text: 'Admin'},
                ]) },
                { key: 'note', title: 'Ghi chú', type: 'text' },
                { key: 'created_at', title: 'Ngày khởi tạo', type: 'date' },
                { key: 'updated_at', title: 'Ngày cập nhật', type: 'date' }
            ];
            
            data[3].data.forEach(field => {
                let _type;
                if(field.type == 'select' || field.type == 'multi-select') {
                    _type = 'select';
                }else if(field.type == 'textarea') {
                    _type = 'text';
                }else _type = field.type;
                let tmp = {
                    key: field.key,
                    title: field.title,
                    type : _type
                }
                if(tmp.type == 'select') {
                    data = field.data || [];
                    data = _.map(data, d => {
                        return {
                            id: d,
                            text: d
                        }
                    })
                    tmp['data']= JSON.stringify(data)
                }
                this.fields.push(tmp)
            });
            this.fields.forEach(e => {
                this.choice[e.key] = false;
            });

        })
    }

    getSortedService(lstServices) {
        let serviceList = [{
            field: "service_id",
            list: [{ id: '', text: '', parent_id: '' }],
            order: 0,
        }];
        lstServices.forEach((c: any) => {
            if (c.parent_id) {
                let order = -1;
                for (let i = 0; i < serviceList.length; i++) {
                    if (order != -1) {
                        break;
                    }
                    for (let j = 0; j < serviceList[i].list.length; j++) {
                        const service = serviceList[i].list[j];
                        if (service.id == c.parent_id) {
                            order = i + 1;
                            break;
                        }
                    }
                }
                if (!serviceList[order]) {
                    serviceList[order] = {
                        field: "service_id" + order,
                        order: order,
                        list: [{
                            text: c.name,
                            id: c.id,
                            parent_id: c.parent_id
                        }],
                    };
                } else {
                    serviceList[order].list.push({
                        text: c.name,
                        id: c.id,
                        parent_id: c.parent_id
                    })
                }
            } else {
                serviceList[0].list.push({
                    text: c.name,
                    id: c.id,
                    parent_id: ''
                })
            }
        });
        return serviceList;
    }

    initFieldTicket() {
        Observable.forkJoin([
            this.ticketService.status(),
            this.userService.all({}),
            this.campaignService.all({}),
            this.fieldService.allField({ target: 'ticket' }),
            this.serviceService.allService()
        ]).subscribe(data => {
            let statusList = [];
            data[0].data.forEach((c: any) => {
                statusList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allStatus = statusList;

            let agentList = [];
            data[1].data.forEach((c: any) => {
                agentList.push({
                    text: c.name,
                    id: c._id,
                });
            });

            this.allAgent = agentList;
            let campaign_list = [];
            data[2].data.list.forEach((c: any) => {
                campaign_list.push({
                    text: c.name,
                    id: c._id,
                });
            });
            this.allCampaign = campaign_list;
            this.fields = [
                { key: 'code', title: 'Mã phiếu ghi', type: 'text' },
                { key: 'campaign_id', title: 'Chiến dịch', type: 'select', data: JSON.stringify(this.allCampaign) },
                { key: 'status', title: 'Trạng thái', type: 'select', data: JSON.stringify(this.allStatus) , data_type: 'number' },
                { key: 'call_id', title: 'Mã cuộc gọi', type: 'text' },
                {
                    key: 'call_status', title: 'Trạng thái trả lời', type: 'select', data: JSON.stringify([
                        { id: 'answer', text: 'Trả lời' },
                        { id: 'reject', text: 'Từ chối' },
                        { id: 'miss', text: 'Nhỡ' }
                    ])
                },
                {
                    key: 'source_detail', title: 'Nguồn khởi tạo', type: 'select', data: JSON.stringify([
                        {id: 'hand', text: 'Thêm mới'},
                        { id: 'call_inbound', text: 'Khách gọi tới' },
                        { id: 'call_outbound', text: 'Gọi điện ra' },
                        { id: 'chat', text: 'Chat' },
                        { id: 'email', text: 'Kênh Email' },
                        { id: 'facebook', text: 'Kênh Facebook' },
                        { id: 'zalo', text: 'Zalo' },
                    ])
                },
                {
                    key: 'finisher', title: 'Đối tượng kết thúc', type: 'select', data: JSON.stringify([
                        { id: 'agent', text: 'Chuyên viên' },
                        { id: 'end_user', text: 'Khách hàng' },
                    ])
                },
                { key: 'receiver_id', title: 'Người tiếp nhận', type: 'select', data: JSON.stringify(this.allAgent) },
                { key: 'assign_agent_id', title: 'Người xử lý', type: 'select', data: JSON.stringify(this.allAgent) },
                { key: 'subject', title: 'Tiêu đề', type: 'text' },
                { key: 'time_start', title: 'Thời gian bắt đầu', type: 'date' },
                { key: 'time_end', title: 'Thời gian kết thúc', type: 'date' },
                { key: 'created_at', title: 'Ngày khởi tạo', type: 'date' },
                { key: 'updated_at', title: 'Ngày cập nhật', type: 'date' },
                { key: 'duedate', title: 'Thời hạn xử lý', type: 'date' },
            ];

            let lstServices = this.getSortedService(data[4].data);
            lstServices.forEach(service => {
                this.fields.push({
                    key: service.field,
                    title: "Nhóm dịch vụ " + service.order,
                    type: 'select',
                    data: JSON.stringify(service.list)
                })
            });


            data[3].data.forEach(field => {
                let _type;
                if(field.type == 'select' || field.type == 'multi-select') {
                    _type = 'select';
                }else if(field.type == 'textarea') {
                    _type = 'text';
                }else _type = field.type;
                let tmp = {
                    key: field.key,
                    title: field.title,
                    type : _type
                }
                if(tmp.type == 'select') {
                    data = field.data || [];
                    data = _.map(data, d => {
                        return {
                            id: d,
                            text: d
                        }
                    })
                    tmp['data']= JSON.stringify(data);
                }
                this.fields.push(tmp)
            });
            this.fields.forEach(e => {
                this.choice[e.key] = false;
            });
        })

    }

    getStatus() {
        this.ticketService.status().toPromise().then(res => {
            let statusList = [];
            res.data.forEach((c: any) => {
                statusList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allStatus = statusList;
        });
    }

    getAllAgent() {
        this.userService.all({}).toPromise().then(res => {
            let agentList = [];
            res.data.forEach((c: any) => {
                agentList.push({
                    text: c.name,
                    id: c._id,
                });
            });

            this.allAgent = agentList;
        });
    }

    getAllCampaign() {
        this.campaignService.all({}).toPromise().then(res => {
            let campaignList = [];
            res.data.list.forEach((c: any) => {
                campaignList.push({
                    text: c.name,
                    id: c._id,
                });
            });
            this.allCampaign = campaignList;
        });
    }

    changedSubAndOr() {
        let text = "Hoặc"
        if (this.model.sub_and_or == 'and') text = 'Và';
        $('.and-or').html(text);
    }

    choiceKey(key, type) {
        let valueKey = $('#key-' + key).is(':checked');
        this.choice[key] = valueKey;
        if (valueKey) {
            this.addCondition(key, 0, type);
        } else {
            $('#dynamic-' + key).html('')
        }
    }

    addMore(key, type) {
        var last = $('#dynamic-' + key).find('.condition-value:last');
        let number = last.data('index') + 1;
        this.addCondition(key, number, type);
    }

    addCondition(key, index, type) {
        let close_margin = "0px";
        if(index != 0){
            close_margin = "-20px";
        }
        let eHtml = ''
        eHtml += `
            <div class="condition-value mb-5" style="background: #d6d6d6; border-radius: 5px;" id="box-`+ key + `-` + index + `" data-index="` + index + `"> `
        if (index > 0) {
            if (this.model.sub_and_or == 'and') {
                eHtml += `<span class="and-or" style="border: 1px solid #d6d6d6;background: white;border-radius: 10px;margin-left: 100px;z-index: 10;text-align: center;display: block;width: 50px;">Và</span>`;
            } else
                eHtml += `<span class="and-or" style="border: 1px solid #d6d6d6;background: white;border-radius: 10px;margin-left: 100px;z-index: 10;text-align: center;display: block;width: 50px;">Hoặc</span>`;
        }
        eHtml += `<a class="btn-close" id="btn-close-` + index + `" href="javascript:closeBox('` + key + `',` + index + `)">
                <i class="icon fa fa-close" style="float: right;margin-top: `+ close_margin +`"></i>
                </a> `
        if (type == 'text') {
            eHtml += `
            <div class="e-value" data-key="` + key + `" id="group-input-` + key + `-` + index + `-eq">
                <input type="radio" name="input-`+ key + `-` + index + `" class="input-value-condition" onchange="javascript:addInput('` + key + `', ` + index + `,'eq','`+type+`')">
                <span class="pl-5">Bằng</span>
            </div>
            <div class="e-value" data-key="`+ key + `" id="group-input-` + key + `-` + index + `-neq">
                <input type="radio" name="input-`+ key + `-` + index + `" class="input-value-condition" onchange="javascript:addInput('` + key + `', ` + index + `,'neq','`+type+`')">
                <span class="pl-5">Không Bằng</span>
            </div>
            <div class="e-value" data-key="`+ key + `" id="group-input-` + key + `-` + index + `-in">
                    <input type="radio" name="input-`+ key + `-` + index + `" class="input-value-condition" onchange="javascript:addInput('` + key + `', ` + index + `,'in','`+type+`')">
                    <span class="pl-5">Có chứa</span>
            </div>
            <div class="e-value" data-key="`+ key + `" id="group-input-` + key + `-` + index + `-nin">
                    <input type="radio" name="input-`+ key + `-` + index + `" class="input-value-condition" onchange="javascript:addInput('` + key + `', ` + index + `,'nin','`+type+`')">
                    <span class="pl-5">Không chứa</span>
            </div>`;
        } else if (type == 'select') {
            eHtml += `
            <div class="e-value" data-key="` + key + `" id="group-input-` + key + `-` + index + `-eq">
                <input type="radio" name="input-`+ key + `-` + index + `" class="input-value-condition" onchange="javascript:addInput('` + key + `', ` + index + `,'eq','`+type+`')">
                <span class="pl-5">Bằng</span>
            </div>
            <div class="e-value" data-key="`+ key + `" id="group-input-` + key + `-` + index + `-neq">
                <input type="radio" name="input-`+ key + `-` + index + `" class="input-value-condition" onchange="javascript:addInput('` + key + `', ` + index + `,'neq','`+type+`')">
                <span class="pl-5">Không Bằng</span>
            </div>`
        } else if (type == 'date') {
            eHtml += `
            <div class="e-value" data-key="` + key + `" id="group-input-` + key + `-` + index + `-eq">
                <input type="radio" name="input-`+ key + `-` + index + `" class="input-value-condition" onchange="javascript:addInput('` + key + `', ` + index + `,'eq','`+type+`')">
                <span class="pl-5">Trong ngày</span>
            </div>
            <div class="e-value" data-key="`+ key + `" id="group-input-` + key + `-` + index + `-gt">
                <input type="radio" name="input-`+ key + `-` + index + `" class="input-value-condition" onchange="javascript:addInput('` + key + `', ` + index + `,'gt','`+type+`')">
                <span class="pl-5">Sau ngày</span>
            </div>
            <div class="e-value" data-key="`+ key + `" id="group-input-` + key + `-` + index + `-lt">
                <input type="radio" name="input-`+ key + `-` + index + `" class="input-value-condition" onchange="javascript:addInput('` + key + `', ` + index + `,'lt','`+type+`')">
                <span class="pl-5">Trước ngày</span>
            </div>`
        }else if(type == 'number') {
            eHtml += `
            <div class="e-value" data-key="` + key + `" id="group-input-` + key + `-` + index + `-eq">
                <input type="radio" name="input-`+ key + `-` + index + `" class="input-value-condition" onchange="javascript:addInput('` + key + `', ` + index + `,'eq','`+type+`')">
                <span class="pl-5">Bằng</span>
            </div>
            <div class="e-value" data-key="`+ key + `" id="group-input-` + key + `-` + index + `-gte">
                <input type="radio" name="input-`+ key + `-` + index + `" class="input-value-condition" onchange="javascript:addInput('` + key + `', ` + index + `,'gte','`+type+`')">
                <span class="pl-5">Lớn hơn</span>
            </div>
            <div class="e-value" data-key="`+ key + `" id="group-input-` + key + `-` + index + `-lte">
                <input type="radio" name="input-`+ key + `-` + index + `" class="input-value-condition" onchange="javascript:addInput('` + key + `', ` + index + `,'lte','`+type+`')">
                <span class="pl-5">Nhỏ hơn</span>
            </div>`
        }
        eHtml += `</div>`;
        $('#dynamic-' + key).append(eHtml);
    }

    loadData(isSearch = false) {
        let that = this;
        let data = {};
        let active_fields = [];
        let number_field = ['status', 'city_id', 'group_id', 'organize_id']

        $('#group-input-condition').find('.input-text').each(function(index){
            var key = $(this).data('key');
            var label = $(this).data('label');
            var val = $(this).val();
            if(val) {
                active_fields.push(key);
                let tmp = {};
                switch(label) {
                    case 'eq': {
                        if (key == "phone") {
                            let eq = {};
                            eq["sub_phone"] = val;
                            tmp = {
                                bool: {
                                    should: [
                                        {term: {sub_phone: val}},
                                        {match: {phone: val}}
                                    ]
                                }
                            }
                        } else {
                            let eq = {};
                            eq[key] = val;
                            tmp = {match : eq}
                        }
                        break;
                    }
                    case 'neq': {
                        let eq = {};
                        eq[key] = val;
                        let neq = {
                            bool : {
                                must_not :  {
                                    match : eq
                                }
                            }
                        }
                        tmp = neq;
                        break;
                    }
                    case 'in': {
                        let query_in = {};
                        query_in[key] = val;

                        tmp = {
                            match_phrase: query_in
                        }
                        break;
                    }
                    case 'nin': {
                        let query_in = {};
                        query_in[key] = val;
                        let neq = {
                            bool : {
                                must_not :  {
                                    match_phrase : query_in
                                }
                            }
                        }
                        tmp = neq;
                        break;
                    }
                    case 'gte' : {
                        let range = {};
                        range[key] = {
                            "gte": val
                        }
                        tmp = {
                            range : range
                        }
                        break;
                    }
                    case 'lte': {
                        let range = {};
                        range[key] = {
                            "lte": val
                        }
                        tmp = {
                            range : range
                        }
                        break;
                    }
                    default: break;
                }

                if(!data[key]) {
                    data[key] = [tmp];
                }else {
                    data[key].push(tmp);
                }
            }
        })

        $('#group-input-condition').find('.input-number').each(function(index){
            var key = $(this).data('key');
            var label = $(this).data('label');
            var val = $(this).val();
            if(val) {
                active_fields.push(key);
                let tmp = {};
                switch(label) {
                    case 'eq': {
                        let eq = {};
                        eq[key] = val;
                        tmp = {match : eq}
                        break;
                    }
                    case 'gte' : {
                        let range = {};
                        range[key] = {
                            "gte": val
                        }
                        tmp = {
                            range : range
                        }
                        break;
                    }
                    case 'lte': {
                        let range = {};
                        range[key] = {
                            "lte": val
                        }
                        tmp = {
                            range : range
                        }
                        break;
                    }
                    default: break;
                }

                if(!data[key]) {
                    data[key] = [tmp];
                }else {
                    data[key].push(tmp);
                }
            }
        })

        $('#group-input-condition').find('.input-select').each(function(index) {
            var key = $(this).data('key');
            var label = $(this).data('label');
            var val = $(this).val();
            var is_number = (number_field.indexOf(key) != -1) ? true : false;

            if(val) {
                active_fields.push(key);
                let tmp = {};
                switch(label) {
                    case 'eq': {
                        let eq = {};
                        if (key.indexOf("ex_ticket") > -1) {
                            eq[key + ".keyword"] = val.toString().toLowerCase();
                        } else {
                            eq[key] = val.toString().toLowerCase();
                        }
                        tmp = { match_phrase: eq }
                        break;
                    }
                    case 'neq': {
                        let eq = {};
                        eq[key] = val.toString().toLowerCase();
                        let neq = {
                            bool : {
                                must_not :  {
                                    match_phrase : eq
                                }
                            }
                        }
                        tmp = neq;
                        break;
                    }
                    default: break;
                }

                if(!data[key]) {
                    data[key] = [tmp];
                }else {
                    data[key].push(tmp);
                }
            }
        })

        $('#group-input-condition').find('.input-date').each(function(index) {
            var key = $(this).data('key');
            var label = $(this).data('label');
            var val = moment($(this).val(),'DD/MM/YYYY');
            let start_date = moment(moment($(this).val(),'DD/MM/YYYY')).format('YYYY-MM-DD')+"T00:00:00.000Z";
            let end_date = moment(moment($(this).val(),'DD/MM/YYYY')).format('YYYY-MM-DD')+"T23:59:59.999Z";
            if(val) {
                active_fields.push(key);
                let tmp = {};
                switch(label) {
                    case 'eq': {
                        let range = {};
                        range[key] = {
                            "gte": start_date,
                            "lte": end_date
                        }
                        tmp = {
                            range : range
                        }
                        break;
                    }
                    case 'gt' : {
                        let range = {};
                        range[key] = {
                            "gt": moment(val).format("YYYY-MM-DD") + "T23:59:59.999Z"
                        }
                        tmp = {
                            range : range
                        }
                        break;
                    }
                    case 'lt': {
                        let range = {};
                        range[key] = {
                            "lt": moment(val).format("YYYY-MM-DD") + "T00:00:00.000Z"
                        }
                        tmp = {
                            range : range
                        }
                        break;
                    }
                    default: break;
                }

                if(!data[key]) {
                    data[key] = [tmp];
                }else {
                    data[key].push(tmp);
                }
            }
        })

        let condition = {};
        let arr = [];
        active_fields = _.union(active_fields);
        active_fields.forEach(field => {
            let sub_condition = {};
            if(this.model.sub_and_or == 'and') {
                sub_condition['must'] = data[field];
            }else {
                sub_condition['should'] = data[field];
            }
            arr.push({
                bool : sub_condition
            });
        });
        if(arr.length > 0) {
            if(this.model.main_and_or == 'and') {
                condition['must'] = arr;
            }else {
                condition['should'] = arr;
            }
        }else {
            condition = {};
        }

        let body = {
            condition : JSON.stringify(condition),
            active_fields : JSON.stringify(active_fields),
            type : this.tab,
            label : this.model.main_and_or,
            sub_label : this.model.sub_and_or,
            keyword : this.model.keyword,
            force_search : 'customer'
        }

        this.data = [];
        if (isSearch) {
            this.currentPage = 1;
        }
        body['offset'] = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
        body['limit'] = this.page_size;
        

        this.searchService.all(body).subscribe(res => {
            if(!res.error && res.status == 200) {
                this.data = res.data.res.list;
                if(this.tab == 'user') {
                    this.data = _.map(this.data, e => {
                        if(e.group_id) {
                            let group = _.find(this.allGroup, {id: parseInt(e.group_id)});
                            if(group) e['group'] = group;
                        }
                        if(e.organize_id) {
                            let org = _.find(this.allOrganize, {id: parseInt(e.organize_id)});
                            if(org) e['organize'] = org;
                        }
                        if(e.city_id) {
                            let  city =  _.find(this.allCity, {id: parseInt(e.city_id)});
                            if(city) e['city'] = city;
                        }
                        return e;
                    })
                }else if(this.tab == 'organize') {
                    this.data = _.map(this.data, e => {
                        if(e.tags) {
                            e.tags = e.tags.split(','); // split để hiển thị trên table
                        }
                        return e;
                    })
                }
                
                this.totalItem = res.data.res.total;
                var pageString = (this.totalItem / this.page_size).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage = totalpage;
                console.log(this.currentPage);
            }
        })
    }

    createFilter() {
        if(this.modelFilter.name && this.modelFilter.name.trim() != '') {
            this.model['data'] = JSON.stringify(this.getForm());
            this.model['name'] =  this.modelFilter['name'].trim();
            this.model['type'] = this.tab;
            if(this.tab == 'ticket'){
                this.model['type_filter'] = 'search_ticket';         
            } else if(this.tab == 'user') {
                this.model['type_filter'] = 'cus_user';         
            } else if(this.tab == 'organize'){
                this.model['type_filter'] = 'search_organize';         
            }
            this.searchService.createFilter(this.model).subscribe(res => {
                if(!res.error){
                    this.loadFilter();
                    this.choiceFilter();
                    this.modalRef2.hide();
                    this.toastr.success('Cập nhật thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.message = res.message;
                }
                
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            })
        } else {
            this.message = { class: "alert dark alert-danger", content: "Tên bộ lọc không được bỏ trống !" };
        }
    }

    updateFilter() {
            this.model['data'] = JSON.stringify(this.getForm());
            this.searchService.updateFilter(this.filter_id, this.model).subscribe(res => {
                if(res.status == 200 && !res.error) {
                    this.loadFilter();
                    this.toastr.success('Cập nhật thành công', '', {
                        timeOut: 1000,
                        positionClass: 'toast-bottom-right'
                    });
                }
            })
    }

    loadFilter() {
        this.searchService.listFilter({type: this.tab}).subscribe(res => {
            if(res.status == 200 && !res.error) {
                this.listFilter = res.data;
            }
        })
    }
    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.loadData();
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.loadData();
                }
            }
        }
    }

    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }

    _keyPress(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }

    openTicket(ticket: any) {
        this.ticketService.find(ticket._id).subscribe(rs => {
            let _ticket = rs.data;
            _ticket['_id'] = ticket._id;
            this.userService.find({ _id: ticket.requester_id }).toPromise().then(res => {
                if (res.status == 200 && res.error == false) {
                    _ticket.request = res.data;
                    this.socketService.opentab(_ticket, 'ticket', 'edit');
                }
            })
        })
    }

    openUser(user) {
        this.socketService.opentab(user,'user','edit');
    }

    openOrganize(org) {
        console.log(org);
        this.socketService.opentab(org, 'organize', 'edit');
    }

    hover(item) {
        this.detailTicket = item;
        this.commentService.list({where: JSON.stringify({ticket_id: this.detailTicket._id}), limit:1}).subscribe(res => {
            if (res.status == 200 && res.error == false && res.data.comments) {
                this.detailTicket['lastest_comment'] = res.data.comments[0] ? res.data.comments[0] : null;
            }
        })
    }

    changeFile($event) {
        var files = $event.srcElement.files;
        this.uploadService.uploadExcel(files[0]).then((res: any) => {
            if (!res.error) {
                let tmpHeaders = [{ id: '', text: '' }];
                res.data.header.forEach((e, index) => {
                    tmpHeaders.push({
                        id: index,
                        text: e
                    })
                });
                this.headers = tmpHeaders;
                this.file_import = res.data.name;
                this.modelImport['step1'] = {
                    type: 'file',
                    data: res.data
                }
                // $event.target.value = null;
            } else {
                this.toastr.error(res.data.message, 'Lỗi', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            }
        })
    }

    choiceFieldMap($event, key) {
        this.mapping[key] = $event.value;
    }

    changedKey($event) {
        this.key = $event.value;
    }

    next(step_id) {
        if (step_id != this.step) {
            this.message = null;
            switch (step_id) {
                case 4: {
                    this.step = step_id;
                    break;
                }
                case 3: {
                    if (_.isEmpty(this.mapping)) {
                        this.message = { class: "alert dark alert-danger", content: "Xin vui lòng liên kết dữ liệu để import" };
                    }else {
                        this.step = step_id;
                        this.saveImport();
                    }
                    break;
                }
                case 2: {
                    if (!this.modelImport.step1 || !this.modelImport.step1.data) {
                            this.message = { class: "alert dark alert-danger", content: "Xin vui lòng upload File khách hàng" };
                    } else {
                            if (!this.key) {
                                this.message = { class: "alert dark alert-danger", content: "Xin vui lòng chọn định danh" };
                            } else this.step = 2;
                    }
                    break;
                }
                case 1: {
                    this.step = step_id;
                    this.mapping = {}
                    break;
                }
                default: break;
            }
        }

    }

    saveImport() {
        let payload = {
            import_type: 'import',
            data: this.mapping,
            target: 'user',
            skip_first_row: this.model.skip_first_row,
            file: this.file_import,
            exec_import: this.exec_import,
            key: this.key
        }

        this.commonService.import(payload).subscribe(res => {
            if (res.error) {
                this.message = { class: "alert dark alert-danger", content: "Có lỗi xảy ra, xin vui lòng thử lại." };
            } else {
                this.current_job = res.data;
                this.current_job['just_now'] = true;
                this.check();
            }
        })
    }

    rejectJob() {
        this.commonService.updateImport(this.current_job._id, { job_status: 'reject' }).subscribe(res => {
            if (!res.error) {
                this.step = 4;
                this.cancel_import = true;
            }
        })
    }

    check() {
        setInterval(function() {
            if(this.step == 3 && this.current_job) {
                this.commonService.findImport({ where: JSON.stringify({_id: this.current_job._id}) }).subscribe(res => {
                    if(!res.error && res.status == 200 && res.data.job_status == 'stop') {
                        this.step = 4;
                        this.file_out = res.data.file_out ? environment.api_evs + res.data.file_out : "";
                    }else  if(this.complete_load < 100) {
                        this.complete_load += 5;
                    }
                })
            }
        }.bind(this), 30000);
    }

}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/search/search.component.ts